// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getFailedTransactionRequest: ['data'],
  getFailedTransactionSuccess: ['data'],
  getFailedTransactionFailure: ['err'],

  triggerFailedTransactionRequest: ['data'],
  triggerFailedTransactionSuccess: ['data'],
  triggerFailedTransactionFailure: ['err']
})

export const FailedTransactionTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

/* ------------- Hook Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FAILED_TRANSACTION_SUCCESS]: success,
  [Types.GET_FAILED_TRANSACTION_REQUEST]: request,
  [Types.GET_FAILED_TRANSACTION_FAILURE]: failure,

  [Types.TRIGGER_FAILED_TRANSACTION_SUCCESS]: success,
  [Types.TRIGGER_FAILED_TRANSACTION_REQUEST]: request,
  [Types.TRIGGER_FAILED_TRANSACTION_FAILURE]: failure
})



// WEBPACK FOOTER //
// ./src/Redux/FailedTransactionRedux.js